import React from 'react';

import Button from '../../../../../../components/Button';

interface ISelectPictureStep {
  save: (e: any) => Promise<any>;
}

export const SelectPictureStep = (props: ISelectPictureStep) => {
  const { save } = props;

  return (
    <div className="select-picture staff-scope">
      <div>
        <h2 className="account-title">SELECT A PICTURE</h2>

        <h5>To update the club logo.</h5>

        <Button id="pick-file" variant={'outlined'} color="primary" fullWidth={true}>
          <label htmlFor="avatar-file-input">USE ONE OF MY PHOTOS</label>

          <input
            type="file"
            id="avatar-file-input"
            onChange={save}
            accept=".jpg,.jpeg,.png"
            hidden={true}
          />
        </Button>
      </div>
    </div>
  );
};
